import React from 'react';
import { SLAB_BOUNDS } from '../../../../game/phaserFacility/facilityLayout';
import { fenceLayout } from '../buildingGeometry';

const POST = '#3a4045';
const MESH = '#7a8a90';
const POST_HEIGHT = 1.3;
const DOUBLE_SIDE = 2; // THREE.DoubleSide

/**
 * Chain-link security fence ringing the facility footprint, with a gate.
 */
export function SecurityFence() {
  const { posts, panels, gate } = fenceLayout(SLAB_BOUNDS);

  return (
    <group>
      {/* Posts */}
      {posts.map(([px, pz], i) => (
        <mesh key={`post-${i}`} position={[px, POST_HEIGHT / 2, pz]} castShadow>
          <cylinderGeometry args={[0.05, 0.05, POST_HEIGHT, 6]} />
          <meshStandardMaterial color={POST} roughness={0.5} metalness={0.6} />
        </mesh>
      ))}

      {/* Chain-link mesh panels with top/bottom rails */}
      {panels.map((p, i) => (
        <group key={`panel-${i}`} position={[p.cx, POST_HEIGHT * 0.5, p.cz]} rotation={[0, p.rotationY, 0]}>
          <mesh>
            <planeGeometry args={[p.length, POST_HEIGHT * 0.85]} />
            <meshStandardMaterial color={MESH} transparent opacity={0.18} roughness={0.6} metalness={0.5} side={DOUBLE_SIDE} depthWrite={false} />
          </mesh>
          <mesh position={[0, POST_HEIGHT * 0.42, 0]}>
            <boxGeometry args={[p.length, 0.04, 0.04]} />
            <meshStandardMaterial color={POST} roughness={0.5} metalness={0.6} />
          </mesh>
          <mesh position={[0, -POST_HEIGHT * 0.42, 0]}>
            <boxGeometry args={[p.length, 0.04, 0.04]} />
            <meshStandardMaterial color={POST} roughness={0.5} metalness={0.6} />
          </mesh>
        </group>
      ))}

      {/* Gate — two panels swung open at the south opening */}
      {[-1, 1].map((dir) => (
        <group
          key={`gate-${dir}`}
          position={[gate.centerX + dir * gate.width * 0.25, POST_HEIGHT * 0.5, gate.z]}
          rotation={[0, (dir * Math.PI) / 6, 0]}
        >
          <mesh>
            <planeGeometry args={[gate.width * 0.5, POST_HEIGHT * 0.85]} />
            <meshStandardMaterial color={MESH} emissive="#3fb950" emissiveIntensity={0.06} transparent opacity={0.25} roughness={0.6} metalness={0.5} side={DOUBLE_SIDE} depthWrite={false} />
          </mesh>
          <mesh position={[0, POST_HEIGHT * 0.42, 0]}>
            <boxGeometry args={[gate.width * 0.5, 0.05, 0.05]} />
            <meshStandardMaterial color={POST} roughness={0.4} metalness={0.7} />
          </mesh>
        </group>
      ))}
    </group>
  );
}
